// firebase
import db from "@/firebase/init";
import firebase from "firebase";
// moment
import moment from "moment";
moment.locale("pt-br");
// services
import store from '@/utils/store.js'
import generateWeeklyMealplan from "../../utils/mealplan.js";

const shoppingService = async (params) => {
    const {
        days
    } = params;

    const generateIngredientList = async () => {
        let ingredientList = [];
        let mealplans = [];
        const mpRef = db
            .collection("mealplans")
            .where("userId", "==", store.state.user.uid)
            .where("day", "in", days);
        if (store.state.user.uid && days) {
            let snapshot = await mpRef.get();
            if (snapshot.empty) {
                await generateWeeklyMealplan(store.state.user.uid);
                let counter = 0;
                do {
                    counter += 1;
                    if (counter > 20) {
                        break;
                    } else {
                        snapshot = await mpRef.get();
                    }
                } while (snapshot.size < store.state.profile.data.meals.length);
            }
            snapshot.forEach(doc => {
                const mealplanObj = {
                    id: doc.id,
                    data: doc.data()
                };
                mealplans.push(mealplanObj);
            });
            if (mealplans.length > 0) {
                let dishList = [];
                for (let i = 0; i < mealplans.length; i++) {
                    dishList.push(mealplans[i].data.chosenDish);
                }
                for (let i = 0; i < dishList.length; i++) {
                    const proportion = dishList[i].proportion;
                    const dishRef = db.collection("dishes").doc(dishList[i].id);
                    const doc = await dishRef.get();
                    const data = doc.data();
                    let foodList = [];
                    if (proportion === 100) {
                        foodList = data.foods;
                    } else if (proportion === 125) {
                        foodList = data.foods125;
                    } else if (proportion === 150) {
                        foodList = data.foods150;
                    } else if (proportion === 175) {
                        foodList = data.foods175;
                    } else if (proportion === 200) {
                        foodList = data.foods200;
                    } else if (proportion === 225) {
                        foodList = data.foods225;
                    } else if (proportion === 250) {
                        foodList = data.foods250;
                    } else if (proportion === 275) {
                        foodList = data.foods275;
                    } else if (proportion === 300) {
                        foodList = data.foods300;
                    } else if (proportion === 325) {
                        foodList = data.foods325;
                    } else if (proportion === 350) {
                        foodList = data.foods350;
                    } else if (proportion === 375) {
                        foodList = data.foods375;
                    } else if (proportion === 400) {
                        foodList = data.foods400;
                    } else {
                        //
                    }
                    for (let i = 0; i < foodList.length; i++) {
                        const ingredients = foodList[i].data.ingredients;
                        for (let j = 0; j < ingredients.length; j++) {
                            if (typeof ingredients[j].data.amount === "number" && ingredients[j].data.amount > 1 && ingredients[j].data.unit === "Portions (100g)") {
                                ingredients[j].data.amount = Math.round(ingredients[j].data.amount);
                            }
                            const ingredientObj = {
                                namePT: ingredients[j].data.namePT,
                                amount: ingredients[j].data.amount,
                                unit: ingredients[j].data.unit,
                                checked: false
                            };
                            ingredientList.push(ingredientObj);
                        }
                    }
                }
            } else {
                return;
            }
        } else {
            return;
        }
        return ingredientList;
    }

    const generateShoppingList = async () => {
        let result = [];
        let nameList = [];
        const list = await generateIngredientList();
        if (list) {
            for (let i = 0; i < list.length; i++) {
                const namePT = list[i].namePT;
                if (nameList.includes(namePT)) {
                    const index = nameList.indexOf(namePT);
                    const amount = list[i].amount;
                    if (amount) {
                        result[index].amount += amount;
                    }
                } else {
                    nameList.push(list[i].namePT);
                    result.push(list[i]);
                }
            }
            for (let i = 0; i < result.length; i++) {
                if (result[i].namePT === "Suco de limão" || result[i].namePT === "Suco de Limão") {
                    result.splice(i, 1);
                }
                if (result[i].unit === "Cups") {
                    result[i].amount = Math.floor(result[i].amount);
                    result[i].unit = "Xícaras (equivalente)";
                    if (result[i].amount === 0) {
                        result[i].amount = 1;
                    }
                    if (result[i].amount < 2) {
                        result[i].unit = "Xícara (equivalente)";
                    }
                } else if (result[i].unit === "Portions (100g)") {
                    result[i].amount *= 100;
                    result[i].unit = "g";
                } else if (result[i].unit === "Tablespoons") {
                    result[i].amount = Math.floor(result[i].amount);
                    if (result[i].amount === 0) {
                        result[i].amount = 20;
                    } else {
                        result[i].amount *= 20;
                    }
                    result[i].unit = "ml";
                } else if (result[i].unit === "Units") {
                    result[i].unit = "Unidades";
                    if (result[i].amount < 2) {
                        result[i].unit = "Unidade";
                    }
                    if (result[i].amount % 1 !== 0) {
                        result[i].amount = result[i].amount + 1 - (result[i].amount % 1);
                    }
                } else {
                    result[i].amount = "";
                    result[i].unit = "";
                }
            }
        } else {
            return;
        }
        return result;
    }

    return await generateShoppingList();
}

export default shoppingService;